import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'; // Input処理
import { SmartadminInputModule } from '../../../shared/forms/input/smartadmin-input.module'; // 日付処理
import { SmartadminDatatableModule } from '../../../shared/ui/datatable/smartadmin-datatable.module'; // グリッド処理
import { SmartadminModule } from '../../../shared/smartadmin.module'; // sa-widget処理
import { UserMangerEditComponent } from './usermangeredit.component';
import { PsDatepickerModule } from '../../../pf.core/datepicker/psdatepicker.module'
import { PsI18nModule } from '../../../pf.core/i18n/psi18n.module';
import { DataTableModule, CheckboxModule } from 'primeng/primeng';
import { SmartadminValidationModule } from '../../../shared/forms/validation/smartadmin-validation.module';
import { ChangePWModule } from "app/pf.main/changepw/changepw.module";


@NgModule({
  imports: [
    CommonModule ,
    FormsModule,
    SmartadminInputModule,
    SmartadminDatatableModule,
    SmartadminValidationModule,
    SmartadminModule,
    PsDatepickerModule,
    PsI18nModule,
    DataTableModule,
    CheckboxModule,
    ChangePWModule
  ],
  declarations: [UserMangerEditComponent],
  exports: [UserMangerEditComponent]
})
export class UserMangerEditModule { }



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/pf.main/usermanger/usermangeredit/usermangeredit.module.ts